// extracted by mini-css-extract-plugin
export default {"player":"nUZDN4Ox8dpizqeYQm1B","footer":"nPGYzh4nN4yB6uLVcukF"};